module.exports = __webpack_public_path__ + "img/major.8d61870a.png";